import React from 'react';
import PropTypes from 'prop-types';
import styles from './ErrorMessage.css';
import { setCardID } from '../../utils/Format/Format';

const ErrorMessageNoData = (props) => {
    const { cardName } = props;
    return (
        <div
            id={setCardID(cardName, true)}
            className="no-data"
            data-testid="no-data-error-message"
        >
            Our system is having trouble displaying this fund’s {cardName} right
            now. Please check back later or{' '}
            <a
                className="help-link"
                href="https://www.troweprice.com/personal-investing/help/contact-us.html?tab=1&que=1"
            >
                contact us
            </a>{' '}
            for help.
            <style jsx>{styles}</style>
        </div>
    );
};

ErrorMessageNoData.propTypes = {
    /**
     * card name to display in the message
     */
    cardName: PropTypes.string
};

ErrorMessageNoData.defaultProps = {
    cardName: ''
};

export default ErrorMessageNoData;
